import { AccountInfo, IPublicClientApplication } from "@azure/msal-browser";
import { authenticatedBackendFetch } from "./ApiService";
import { FeedbackPostDTO } from "../types/FeedbackPostDTO";
import { CreatePostDTO } from "../types/CreatePostDTO";

export async function GetOpenFeedbackPosts(
  instance: IPublicClientApplication,
  account: AccountInfo,
) {
  const response = await authenticatedBackendFetch("posts/open", instance, account);

  if (!response.ok) {
    console.error(response);
    return [];
  }

  const posts: FeedbackPostDTO[] = await response.json();

  const sortedPosts = posts.sort((a, b) => b.likeCount - a.likeCount);

  return sortedPosts;
}

export async function GetAllFeedbackPosts(
  instance: IPublicClientApplication,
  account: AccountInfo,
) {
  const response = await authenticatedBackendFetch("posts", instance, account);

  if (!response.ok) {
    console.error(response);
    return [];
  }

  const posts: FeedbackPostDTO[] = await response.json();

  const sortedPosts = posts.sort((a, b) => b.likeCount - a.likeCount);

  return sortedPosts;
}

export async function CreateNewPostAsync(
  instance: IPublicClientApplication,
  account: AccountInfo,
  postToCreate: CreatePostDTO,
) {
  const response = await authenticatedBackendFetch("posts/create", instance, account, {
    method: "POST",
    body: JSON.stringify(postToCreate),
  });

  if (!response.ok) {
    console.error(response);
    throw new Error("BadRequest");
  }
}

export async function TogglePostLikeAsync(
  instance: IPublicClientApplication,
  account: AccountInfo,
  postId: number,
  userId: number,
) {
  const response = await authenticatedBackendFetch("posts/like", instance, account, {
    method: "POST",
    body: JSON.stringify({ postId, userId }),
  });

  if (!response.ok) {
    console.error(response);
    throw new Error("BadRequest");
  }
}

export async function MarkFeedbackPostAsCompleteAsync(
  instance: IPublicClientApplication,
  account: AccountInfo,
  postId: number,
  userId: number,
) {
  const response = await authenticatedBackendFetch("posts/complete", instance, account, {
    method: "POST",
    body: JSON.stringify({ postId, userId }),
  });

  if (!response.ok) {
    console.error(response);
    throw new Error("BadRequest");
  }
}
